import React from "react";
import { Link } from "react-router-dom";
import { appHistory } from "@/router/history";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";

import RichText from "./Common/RichText";
import { Button } from "./ui";
import { withContentData, type ContentQueryProps } from "api/queries/useContent";
import { withAuthData, type AuthInjectedProps } from "../context/AuthContext";

interface EndUserAgreementPageOwnProps extends WithTranslation {
  userLoggedIn?: boolean;
}

type EndUserAgreementPageProps = EndUserAgreementPageOwnProps &
  ContentQueryProps &
  AuthInjectedProps;

const EULA_SLUG = "text_eula";

function EndUserAgreementPage({ t, contents, userLoggedIn, actions }: EndUserAgreementPageProps) {
  React.useEffect(() => {
    if (!userLoggedIn) {
      appHistory.push(BASE_PATH + "/login");
    }
  }, [userLoggedIn]);

  if (!userLoggedIn) {
    return null;
  }

  const page = contents[EULA_SLUG];

  return (
    <div className="Page AuthPage EndUserAgreementPageShell">
      <div className="Page-content AuthPage-content">
        <div className="AuthPage-header">
          <div className="LogoCompanyWrapper">
            <Link to={BASE_PATH + "/"}>
              <div className="LogoCompany isSpaced isGMC"></div>
            </Link>
          </div>
          <p className="AuthPage-kicker">{t("topbar.platform_label")}</p>
          <h2 className="Page-title isSpaced">{page ? page.title : null}</h2>
        </div>

        <section className="AuthPage-panel EndUserAgreement">
          <RichText className="EndUserAgreement-textBlock" html={page ? page.content : ""} />
          <div className="EndUserAgreement-actionBlock">
            <Button
              size="lg"
              className="EndUserAgreement-button Button isLarge"
              onClick={actions.acceptLicence}
            >
              {t("common.button_accept")}
            </Button>
            <Button
              variant="secondary"
              size="lg"
              className="EndUserAgreement-button Button isLarge AuthPage-secondaryAction"
              onClick={actions.refuseLicence}
            >
              {t("common.button_decline")}
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default compose(withTranslation(), withAuthData, withContentData)(EndUserAgreementPage);
